/**
 * RBAC module slug is `lecture_swap` (UI label: Lecture Swap).
 * Keep in sync with backend checkPermission() on routes and permissionSeeds.js.
 */

export const LECTURE_SWAP_MODULE_KEY = "lecture_swap";

/** Swap slugs. */
export const LECTURE_SWAP_REQUEST_PERMISSION = "lecture_swap.request";
export const LECTURE_SWAP_RESPOND_PERMISSION = "lecture_swap.respond";
export const LECTURE_SWAP_FORCE_PERMISSION = "lecture_swap.force";
export const LECTURE_SWAP_VIEW_PERMISSION = "lecture_swap.view";

/** Extend slugs (same module, shares the `lecture_swap.view` slug for reads). */
export const LECTURE_EXTEND_REQUEST_PERMISSION = "lecture_swap.extend_request";
export const LECTURE_EXTEND_RESPOND_PERMISSION = "lecture_swap.extend_respond";
export const LECTURE_EXTEND_FORCE_PERMISSION = "lecture_swap.extend_force";

/** Open the swap/extend management menu / routes (view history + available targets). */
export const LECTURE_SWAP_MENU_PERMISSIONS = [
  LECTURE_SWAP_VIEW_PERMISSION,
  LECTURE_SWAP_REQUEST_PERMISSION,
  LECTURE_SWAP_RESPOND_PERMISSION,
  LECTURE_EXTEND_REQUEST_PERMISSION,
  LECTURE_EXTEND_RESPOND_PERMISSION,
];

/** Accept / reject actions on a pending row. */
export const LECTURE_SWAP_ACTION_PERMISSIONS = [
  LECTURE_SWAP_RESPOND_PERMISSION,
  LECTURE_EXTEND_RESPOND_PERMISSION,
];

/** Force (no-consent) actions, restricted to hod / institute / admin by default. */
export const LECTURE_SWAP_FORCE_PERMISSIONS = [
  LECTURE_SWAP_FORCE_PERMISSION,
  LECTURE_EXTEND_FORCE_PERMISSION,
];

/** All seven slugs in the module. */
export const ALL_LECTURE_SWAP_PERMISSIONS = [
  LECTURE_SWAP_REQUEST_PERMISSION,
  LECTURE_SWAP_RESPOND_PERMISSION,
  LECTURE_SWAP_FORCE_PERMISSION,
  LECTURE_SWAP_VIEW_PERMISSION,
  LECTURE_EXTEND_REQUEST_PERMISSION,
  LECTURE_EXTEND_RESPOND_PERMISSION,
  LECTURE_EXTEND_FORCE_PERMISSION,
];
